export default {
  '主頁': 'Halaman Utama',
  '一般查證': 'Cek ID',
  '大量查證': 'Cek banyak ID',
  '上傳檔案': 'Upload data',
  '下載查證結果': 'Unduh hasil Cek ID',
  '下載格式': 'Unduh format tabel',
  '大量查證失敗!請確認上傳格式是否正確，或聯絡開通中心 0800-222-179 ，謝謝': 'Cek ID gagal! Pastikan unggahan sdh benar atau hub:: (02) 8227-3308 extension 20 atau 21, terima kasih',
  '補卡查證': 'Ganti SIM',
  '升級查證': 'Upgrade SIM',
  '門號查詢': 'Cek SIM',
  '查證紀錄': 'Record pengecekan',
  '問題紀錄': 'Record masalah',
  '登出': 'Log Out',
  '快速功能': 'Cara cepat',
  '快速搜尋': 'Cari',
  '近期記錄': 'Laporan terbaru',
  '日期': 'Tgl',
  '證號': 'No.ID/Pasport',
  '結果': 'Hasil',
  '備註': 'Keterangan',
  '當查證結果等待超過5分鐘時，請聯絡開通中心 02-8227-3308分機20及21，謝謝': "Cek ID lebih dr 5 menit belum dijawab, telp ke : (02) 8227-3308 extension 20 atau 21",
  '已辦過': 'Sudah  daftar',
  '已辦門號': 'Sudah pernah daftar',
  '欠費': 'Ada tunggakan',
  '風險': 'Beresiko',
  '有人查過': 'Sudah di Cek orang',
  '護照號碼': 'No. Pasport',
  '目前身份': 'Kode Pengguna',
  '門號': 'No.SIM Card',
  '身分證字號': 'No.KTP Taiwan',
  '身分證驗證': 'Cek KTP Taiwan',
  '請選擇證件類別': 'Pilih Jenis ID',
  '請輸入證號': 'Masukkan No.ID',
  '居留證查詢': 'Cek KTP Taiwan',
  '請輸入生日': 'Masukkan Tgl Lahir',
  '生日 為必填': 'Tgl lahir harus diisi',
  '國籍 為必填': 'Kewarganegaraan harus diisi',
  '生日': 'Tgl Lahir',
  '國籍': 'Kewarganegaraan',
  '泰國': 'Thailand',
  '印尼': 'Indonesia',
  '越南': 'Vietnam',
  '菲律賓': 'Philippine',
  '印度': 'India',
  '其他': 'Other',
  '中國': 'China',
  '確定':  'Pastikan',
  '確定送出': 'Pastikan Kirim',
  '查證系統': 'Sistem Cek ID',
  '請先登入系統': ' Log in ke Sistem dulu',
  '手機號碼': 'No.HP',
  '取得簡訊驗證碼': 'Dapatkan kode verifikasi dr SMS',
  '認證碼': 'Kode Verifikasi',
  '重新發送驗證碼': 'kirim ulang kode verifikasi',
  '登入系統': 'Log in',
  '驗證碼錯誤': 'Kode verifikasi salah',
  '系統目前無法登入，請聯絡開通中心 02-8227-3308分機20及21。': "Tidak bisa Log in, telp ke (02) 8227-3308 extension 20 atau 21",
  '此電話號碼不存在': 'No.HP tidak terdaftar',
  '無法取的認證碼，請聯絡開通中心 02-8227-3308分機20及21。': "Tidak terima kode verifikasi, telp ke  (02) 8227-3308 extension 20 atau 21",
  '問題件': 'SIM Card bermasalah',
  '辦門號': 'Daftar',
  '系統編號': 'No.Sistem',
  '門號類型': 'Kategori',
  '辦門號記錄': 'Record pengaktifan',
  '狀態': 'Status',
  '一般門號': 'Daftar baru',
  '升級': 'Upgrade SIM',
  '換補卡': 'Ganti SIM  hilang/rusak',
  '卡號': 'No. Seri',
  '此卡不在庫存內，請聯絡相關人員。': "No. SIM  tidak ada, hubungi yg memberi SIM ",
  '聯絡電話': 'No. HP yg bisa dihubungi',
  '預計開通日': 'Tgl pengaktifan',
  '仲介名': 'Nama Agen',
  '認證電話': 'Verifikasi No.HP',
  '看申請書': 'Lihat Formulir',
  '中華申請書': 'Perjanjian Syarat dftr Chunghwa',
  '請用正楷簽名': 'Tekan & Tulis nama lengkap',
  '確認簽名': 'Pastikan',
  '請閱讀申請書並簽名': 'Baca formulir & tulis nama lengkap',
  '請將 QRCODE 對準掃瞄框': 'Scan kode QR',
  '掃描錯誤，內容如下:': 'Scan gagal, sebab:',
  '您必須打開鏡頭權限': 'Izinkan membuka kamera',
  '找不到相機': 'Kamera tidak ditemukan',
  '相機已經被其他程式佔用': 'Kamera sdh dipakai  program lain',
  '系統無法支援此瀏覽器': 'Sistem tidak  mendukung Web ini',
  '重新掃描': 'Scan ulang',
  '清除': 'Hapus',
  '取消': 'Batal',
  '我已閱讀{term}並同意加入九亨會員': 'Saya {term} & setuju bergabung jadi anggota Best We Serve Intl Co. Ltd',
  '閱讀條款': 'telah membaca Syarat Ketentuan',
  '請檢查所有欄位是否填寫正確': 'Cek apakah  semua data sdh diisi dgn benar',
  '送件': 'Kirim',
  '暫存': 'Simpan dulu',
  '關閉': 'Tutup',
  '刪除': 'Hapus',
  '上傳中': 'Upload',
  '讀取中': 'Uploading',
  '送件完成': 'Pengiriman berhasil',
  '暫存成功': 'Berhasil simpan dulu',
  '抱歉！找不到此暫存件！': 'Maaf! data tdk ada',
  '確定刪除照片嗎？': 'Yakin  menghapus foto?',
  '確定要刪除此筆？所有的資料都會消失，此動作不可復原？': 'Yakin  menghapus ? semua data akan hilang',
  '刪除成功': 'Berhasil dihapus',
  '抱歉！無法暫存，請稍後再試！': 'Tidak bisa menyimpan , coba lagi!',
  '全部': 'Semua',
  '抱歉！刪除失敗，請稍後再試！': "Maaf!gagal menghapus, coba lagi ",
  '未進件': 'Data belum diterima',
  '已送件': 'Data terkirim',
  '預計開通': 'Tgl diaktifkan',
  '已開通': 'SIM sdh aktif',
  '已退卡': 'SIM sdh dikembalikan',
  '已停話': '已停話',
  '照片張數 不得小於{0}': 'Foto tdk boleh kurang dari {0}',
  '門號 為必填': 'No. SIM  harus di isi',
  '卡號 為必填': 'No. Seri  harus di isi',
  '門號不完整': 'No. SIM tdk lengkap',
  '抱歉! 無法暫存，請稍後再試!': 'Tidak bisa menyimpan , coba lagi!',
  '照片數不能超過 7 張': 'Foto tdk boleh lebih dari 7',
  '回辦門號紀錄': 'Record pendaftaran SIM',
  '繼續辦門號': 'Lanjutkan daftar',
  '回主畫面': 'Kembali ke layar utama',
  '查證': 'Cek ID',
  '我己閱讀並了解': 'Saya sudah membaca & mengerti',
  '如特定開通日期，才需點選': 'Jika akan diaktifkan tgl tertentu baru diisi',

  // 大量查證
  '班機': 'isi nomor penerbangan',
  '班機狀態': 'status penerbangan',
  '未知': 'tidak ada informasi penerbangan hari ini',
  '準時': 'tepat waktu',
  '取消': 'batal',
  '延誤': 'keterlambatan kedatangan',
  '時間變更': 'perubahan waktu',
  '抵達': 'kedatangan',
  '表定抵達時間': 'Waktu kedatangan',
  '班機為必填': 'Nomor penerbangan harus diisi',
  '落地日期': 'Tgl tiba',
  '落地日期及時間 為必填': 'Tgl & waktu tiba hrs diisi',
  '拍正反面：居留證、身份證、學生證、駕照': 'Foto depan belakang ARC/ Paspor, Kartu kesehatan/VISA termasuk stempel masuk Taiwan & Foto orang yg mendaftar',
  '護照、簽證(VISA)、勞動契約及全身照': 'Foto Paspor, VISA, Surat Kontrak Kerja & Foto orang yg mendaftar',
  '看申請書並正楷簽名': 'Baca formulir & tulis nama lengkap',
  '重簽名': 'Ulangi tulis nama',
  '上傳照片': 'Upload foto',
  '增加照片': 'Tambah foto',
  '3張以上,最多7張': 'minimal 3 lbr foto maksimal 7 lbr foto',
  '大量辦門號': 'Daftar banyak SIM ',
  '選取照片': 'Pilih foto',
  '點擊上傳或是拖曳照片到畫面中': 'Klik utk unggah /seret foto ke layar',
  '目前總共選取了{0}張照片': 'Ada {0} lbr foto yg dipilih',
  '重新選擇': 'Pilih kembali',
  '上傳照片': 'Upload foto',
  '為了上傳更有效率，建議請將圖檔尺寸在 1200x1200 內。': 'Spy upload lebih efisien,  ukuran gbr antara 1200x1200',
  '檔名': 'Nama file',
  '檔案大小': 'Ukuran file',
  '下一步': 'Selanjutnya',
  '上傳失敗！請確認一下網路狀態，或是稍後再試。\n若持續有問題，請聯絡系統管理員。(請聯絡開通中心02-8227-3308分機20及21，謝謝)': 'Gagal upload data, periksa koneksi internet/ coba lagi \nhub: (02) 8227-3308 extension 20 atau 21',
  '大量辦門號成功!': 'Pendaftaran banyak SIM berhasil!',
  '辦門號紀錄上傳中，請勿關閉視窗。': 'Sedang upload data, jgn menutup layar',
  'SIM卡庫存': 'Stok SIM',
  '庫存': 'Stok',
  '類型': 'Jenis',
  '動作': 'Pilih',
  '照片數': 'Jumlah foto',
  '上傳狀態': 'Status unggahan',
  '上一步': 'Sebelumnya',
  '目前比對出{0}筆可送件辦門號, 請確認': 'Pencocokan saat ini ada 0 data yg bisa dikirim, mohon cek',
  '暫存門號需有簽名才能比對': 'Foto yg disimpan sementara hrs ada nama pendaftar pd formulir',
  '單一門號照片數量,3張以上最多的7張': '1 SIM jumlah foto nya diatas 3 lbr & plg banyak 7 lbr',
  '照片檔要符合檔名規則09XXXXXXXX': 'File foto namanya hrs pakai No.SIM 09XXXXXXXX',
  'API呼叫失敗': 'API call failed',

  // 問題件說明
  '問題件類型': 'Jenis masalah',
  '問題件說明': 'Deskripsi masalah',
  '證件': 'ID',
  '欠費-本期.呆帳.拆機': 'Tunggakan saat ini',
  '簽名': 'Nama lengkap',
  '未開通卡片遺失': 'SIM hilang (belum aktif)',
  '台灣人': 'Orang Taiwan',
  '未滿18歲': 'Umur belum 18 thn ',
  '流程重做': 'Proses ulang',
  '升級.補卡資料不符': 'Upgrade/ganti SIM data tdk cocok',
  '非本人': 'Bukan pendaftar',
  '人像照': 'Foto orang',
  '補件': 'Tambah data',
  '其他': 'Lainnya',
  '[201]': 'verifikasi gagal, silahkan coba kembali nanti',
  '[OR1102]': 'verifikasi gagal, silahkan coba kembali nanti',
  '[OR4212]': '',
  '[OR421A]': 'tidak dapat langsung diaktifkan atau tidak dapat diaktifkan',
  '[OR421B]': 'verifikasi gagal, silahkan coba kembali nanti',
  '[OR421C]': 'tidak dapat langsung diaktifkan atau tidak dapat diaktifkan',
  '[OR5101]': 'verifikasi gagal, silahkan coba kembali nanti',
  '[OR5101]': 'verifikasi gagal, silahkan coba kembali nanti',
  '[OR4210]': 'verifikasi gagal, silahkan coba kembali nanti',
  '[OR4211]': '',
  '[OR4213]': '',
  '[OR4214]': '',
}
